// extracted by mini-css-extract-plugin
module.exports = {"accessoriesComp":"accessories_accessoriesComp__SaZG1"};